import Head from 'next/head';
import { ReactNode } from 'react';

export interface PageProps {
  title?: string;
  children: ReactNode;
}

export const Page = ({ title, children }: PageProps) => {
  return (
    <>
      {/* <Head> */}
      {/*  <title>{title} | Relaypay</title> */}
      {/* </Head> */}
      {children}
    </>
  );
};
